import { Flex } from "@chakra-ui/react";
import { useContaStore } from "features/conta/store";
import { OperacaoEnum } from "core/resources/enums/conta";
import { PermissaoEnum } from "core/resources/enums/permissao";
import PageHeader from "components/Page/PageHeader";
import SelectTipoData from "components/Input/SelectTipoData";
import DateRangePicker from "components/Input/DateRangePicker";

function HeaderConta({ onClick }: { onClick: () => void }) {
  const { filters, update } = useContaStore();

  return (
    <>
      <PageHeader
        title={`Contas a ${
          filters.operacao === OperacaoEnum.Despesa ? "pagar" : "receber"
        }`}
        titleButton={`Cadastrar contas a ${
          filters.operacao === OperacaoEnum.Despesa ? "pagar" : "receber"
        }`}
        permissions={[
          filters.operacao === OperacaoEnum.Despesa
            ? PermissaoEnum.Backoffice.Financeiro.ContasPagar.Criar
            : PermissaoEnum.Backoffice.Financeiro.ContasReceber.Criar,
        ]}
        midComponent={
          <Flex gap="16px" minW="420px">
            <DateRangePicker
              allowEmptyDates={{
                dataInicio: true,
                dataFim: false,
              }}
              onChange={(dataInicio, dataFim) => {
                update({
                  dataInicio: dataInicio,
                  dataFim: dataFim,
                });
              }}
              value={{
                dataInicio: filters.dataInicio!,
                dataFim: filters.dataFim!,
              }}
            />

            <Flex w="200px">
              <SelectTipoData
                allowClear={true}
                bg="white"
                style={{ border: "1px solid #ccc", borderRadius: 6 }}
                value={filters.tipoData}
                onChange={(v) => update("tipoData", v)}
                operacao={filters.operacao}
                filterOptions={["geracao"]}
              />
            </Flex>
          </Flex>
        }
        onClick={() => onClick()}
      />
    </>
  );
}

export default HeaderConta;
